import CryptoJS from 'crypto-js';

interface StoreData {
  costumes: Record<number, boolean>;
  playername: string;
  nameChanged: boolean;
  code?: string;
  friendsCode?: string;
}

class Store {
  public static readonly instance: Store = new Store();
  public data: StoreData;
  public state: { locale: string; hp: number; score: number; costume: number; volume: number; adLoaded: boolean } = {
    locale: navigator.language === 'ko-KR' ? 'ko-KR' : 'en-US',
    hp: 5,
    score: 0,
    costume: 0,
    volume: 1,
    adLoaded: false,
  };

  constructor() {
    this.data = this.load();
  }

  private load(): StoreData {
    try {
      const data = JSON.parse(
        this.d(localStorage.getItem('ninimo_adventure') || '', '89Gr9JE3HLD0KEMeAsbKCC7XLts5552w')
      );

      if (!data.playername) {
        data.playername = 'User';
      }
      if (data.nameChanged === undefined) {
        data.nameChanged = false;
      }

      return data;
    } catch (e) {
      return {
        playername: 'User',
        nameChanged: false,
        code: undefined,
        friendsCode: undefined,
        costumes: {
          0: true,
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
        },
      };
    }
  }

  public save(): void {
    localStorage.setItem('ninimo_adventure', this.e(JSON.stringify(this.data), '89Gr9JE3HLD0KEMeAsbKCC7XLts5552w'));
  }

  public e(value: string, key: string): string {
    return CryptoJS.AES.encrypt(value, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse('2QUiAeLjqIkCeXK7'),
      mode: CryptoJS.mode.CBC,
      format: CryptoJS.format.Hex,
    }).toString();
  }

  public d(value: string, key: string): string {
    return CryptoJS.AES.decrypt(value, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse('2QUiAeLjqIkCeXK7'),
      mode: CryptoJS.mode.CBC,
      format: CryptoJS.format.Hex,
    }).toString(CryptoJS.enc.Utf8);
  }
}

export default Store;
